function checkForIE() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");

  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    // If Internet Explorer, return version number
    return `
        <div class="pl-5 pr-5 pt-3 pb-3" style="background-color: bisque;">
            <h5 align="center">Your browser (Internet Explorer) is <strong>NOT SUPPORTED</strong> by this site! Some
                functionality will be lost.
                <br><strong>Please switch to another web browser.</strong>
            </h5>
        </div>
    `;
  } // If another browser, return 0
  else {
    return "";
  }
}

import navy_blue_logo from "/images/navy-blue-logo.png"; // is the path to the bundles css file

//Insert navbar into already created <div id='navbar'></div>
var navbar = document.getElementById("navbar");

var navbar_innerHTML = checkForIE();
navbar_innerHTML +=
  "<nav class='navbar navbar-expand-lg navbar-light bg-white'>" +
  "<div class='container'>" +
  `<a href='index.html' class='navbar-left'><img src='${navy_blue_logo}' style='max-width: 100px;'></a>` +
  "<a class='navbar-brand mr-5 title-in-navbar' style='margin-left: 20px;' href='index.html'>Tapestry of Love Ministries</a>" +
  "<button class='navbar-toggler' type='button' data-toggle='collapse' data-target='#navbarNavAltMarkup' aria-controls='navbarNavAltMarkup' aria-expanded='false' aria-label='Toggle navigation'>" +
  "<span class='navbar-toggler-icon'></span>" +
  "</button>" +
  "<div class='collapse navbar-collapse justify-content-lg-end' id='navbarNavAltMarkup'>" +
  "<ul class='navbar-nav'>" +
  "<li class='nav-item'><a class='nav-link' href='index.html'>Home<span class='sr-only'>(current)</span></a></li>" +
  "<li class='nav-item dropdown'>" +
  "<a id='aboutUsDropdown' class='nav-link dropdown-toggle' href='#' id='navbarDropdown' role='button' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'>About Us</a>" +
  "<div class='dropdown-menu' aria-labelledby='navbarDropdown'>" +
  "<a class='nav-link' href='about-tolm.html'>About TOLM</a>" +
  "<a class='nav-link' href='about-our-history.html'>About Our History</a>" +
  "<a class='nav-link' href='about-magdalena.html'>About Magdalena</a>" +
  "<a class='nav-link' href='about-mount-sinai-christian-school.html'>About Mount Sinai Christian School</a>" +
  "<a class='nav-link' href='about-mount-sinai-evangelical-mission-church.html'>About Mount Sinai Evangelical Mission Church</a>" +
  "<a class='nav-link' href='about-how-we-operate.html'>About How We Operate</a>" +
  "<a class='nav-link' href='our-team.html'>Our Team</a>" +
  "</div>" +
  "</li>" +
  "<li class='nav-item dropdown'>" +
  "<a class='nav-link dropdown-toggle' href='#' id='navbarDropdown' role='button' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'>Sponsorship Programs</a>" +
  "<div class='dropdown-menu' aria-labelledby='navbarDropdown'>" +
  "<a class='nav-link' href='child-sponsorship.html'>Child Sponsorship</a>" +
  "<a class='nav-link' href='teacher-sponsorship.html'>Teacher Sponsorship</a>" +
  "<a class='nav-link' href='missionary-sponsorship.html'>Missionary Sponsorship</a>" +
  "<a class='nav-link' href='projects-and-programs.html'>Projects and Programs</a>" +
  "</div>" +
  "</li>" +
  "<li class='nav-item dropdown'>" +
  "<a class='nav-link dropdown-toggle' href='#' id='navbarDropdown' role='button' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'>Get Involved</a>" +
  "<div class='dropdown-menu' aria-labelledby='navbarDropdown'>" +
  "<a class='nav-link' href='get-involved.html'>Overview</a>" +
  "<a class='nav-link' href='gala-2025.html'>Gala 2025</a>" +
  "<a class='nav-link' href='mission-trips.html'>Mission Trips</a>" +
  "<a class='nav-link' href='intern.html'>Intern</a>" +
  "</div>" +
  "</li>" +
  "<li class='nav-item dropdown'>" +
  "<a class='nav-link dropdown-toggle' href='#' id='navbarDropdown' role='button' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'>Media</a>" +
  "<div class='dropdown-menu' aria-labelledby='navbarDropdown'>" +
  "<a class='nav-link' href='video-gallery.html'>Video Gallery</a>" +
  "<a class='nav-link' href='blog-posts.html'>Blog</a>" +
  "</div>" +
  "</li>" +
  "<li class='nav-item dropdown'>" +
  "<a class='nav-link dropdown-toggle' href='#' id='navbarDropdown' role='button' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'>Give</a>" +
  "<div class='dropdown-menu' aria-labelledby='navbarDropdown'>" +
  "<a class='nav-link' href='give.html'>Give</a>" +
  "<a class='nav-link' href='virtual-catalog.html'>Shop TOLM</a>" +
  "</div>" +
  "</li>" +
  // "<li class='nav-item'><a class='nav-item nav-link' href='give.html'>Give</a></li>" +
  "<a id='btnLoginPage' class='btn btn-primary ml-3' style='max-height: 40px' href='login.html'>Login</a>" +
  "<a id='btnMyAccount' class='btn btn-primary ml-3' style='max-height: 40px' href='my-account.html'>My Account</a>" +
  "<a id='btnLogout' class='btn btn-primary ml-3' style='max-height: 40px' href='#'>Logout</a>" +
  "</ul>" +
  "</div>" +
  "</div>" +
  "</nav>";

navbar.innerHTML = navbar_innerHTML;

$(".dropdown").hover(
  function () {
    $(this).find(".dropdown-menu").stop(true, true).delay(50).slideDown();
  },
  function () {
    $(this).find(".dropdown-menu").stop(true, true).delay(50).slideUp();
  }
);

$(".dropdown-menu").hover(
  function () {
    $(this).stop(true, true);
  },
  function () {
    $(this).stop(true, true).delay(50).slideUp();
  }
);

// Insert footer into already created < footer id = "footer" ></footer >

//================================================================================================
//Use JS to load font awesome stylesheet for social media icons in footer
// Get HTML head element
var head = document.getElementsByTagName("HEAD")[0];
// Create new link Element
var fontAwesomeUri = document.createElement("link");
// set the attributes for link element
fontAwesomeUri.rel = "stylesheet";
fontAwesomeUri.type = "text/css";
fontAwesomeUri.href =
  "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css";
// Append link element to HTML head
head.appendChild(fontAwesomeUri);
//================================================================================================

var footer = document.getElementById("footer");
footer.innerHTML = `
<footer>
<div class="container-fluid"></div>
<div class="row text-center">
    <div class="col-md-4 mb-2 mb-md-0">
        <h4 style="font-weight: 500;">TOLM</h4>
        <hr class="light">
        <p><strong>Email:</strong> <a href="mailto:admin@tolmguate.org">admin@tolmguate.org</a></p>
        <p><strong>Phone:</strong> 314-474-0065</p>
        <p>3035 Nameoki Dr.</p>
        <p>Granite City, IL 62040</p>
    </div>
    <div class="col-md-4 mb-2 mb-md-0">
        <h4 style="font-weight: 500;">Sponsorship</h4>
        <hr class="light">
        <p><a href="child-sponsorship.html">Child Sponsorship</a></p>
        <p><a href="teacher-sponsorship.html">Teacher Sponsorship</a></p>
        <p><a href="missionary-sponsorship.html">Missionary Sponsorship</a></p>
    </div>
    <div class="col-md-4 social padding">
        <h4 style="font-weight: 500;">Social Media</h4>
        <hr class="light">
        <a href="https://www.facebook.com/tolmguatemala/"><i class="fa fa-facebook"></i></a>
        <a href="https://www.instagram.com/tolmguate/"><i class="fa fa-instagram"></i></a>
    </div>
</div>
<div class="row text-center">
    <div class="col-12 mt-2">
        <hr class="light">
        <p>&copy; 2025 Tapestry of Love Ministries</p>
        <small>
            <p>All brand logos, photos, and images are property of TOLM and may not be used without
                expressed written permission.</p>
        </small>
        <small>
            <p>Tapestry of Love Ministries is a 501(c)3 nonprofit organization. Donations are tax deductible
                as allowed by law.</p>
        </small>
    </div>
</div>
<div class="row text-center mt-4 align-items-center justify-content-center">
        <div class="col-4 text-right mx-auto">
            <a href="https://www.guidestar.org/profile/shared/734a75f3-7b0c-44c9-aa87-0c955ec7e3f7" target="_blank">
                <img src="https://widgets.guidestar.org/TransparencySeal/9649251"/>
            </a>
        </div>
        <div class="col-4 text-center mx-auto">
            <a href="https://greatnonprofits.org/org/tapestry-of-love-ministries/?badge=1" target="_blank"> 
                <img alt="Review Tapestry Of Love Ministries on Great Nonprofits" title="Review Tapestry Of Love Ministries on Great Nonprofits" src="//cdn.greatnonprofits.org/images/great-nonprofits.gif?id=997156072"> 
            </a>
        </div>
        
        <div class="col-4 text-left mx-auto">
            <a href="https://greatnonprofits.org/org/tapestry-of-love-ministries" target="_blank">
                <img width="150px" height="113px" src="//cdn.greatnonprofits.org//img/2024-top-rated-awards-badge-embed.png?id=997156072" alt="Tapestry Of Love Ministries Nonprofit Overview and Reviews on GreatNonprofits" title="2024 Top-rated nonprofits and charities" alt="Tapestry Of Love Ministries Nonprofit Overview and Reviews on GreatNonprofits" title="2024 Top-rated nonprofits and charities">
            </a>
        </div>
    
</div>
</footer>
    `;
document.getElementById("btnLogout").onclick = function () {
  firebase
    .auth()
    .signOut()
    .then(function () {
      window.location.reload();
    });
};
